import { useTranslate } from '@tolgee/react'
import { TomAutoComplete, TomAutoCompleteProps } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'

type BooleanEntity = { display: string; value?: boolean }

type Props = {
  label: string
  entityDisplayTrue: string
  entityDisplayFalse: string
  selectedValue?: boolean
  onChange: (value: boolean | undefined) => void
} & TomAutoCompleteProps<BooleanEntity, false>

export const BooleanAutoComplete = observer((props: Props) => {
  const { t } = useTranslate()
  const { dataCy, label, selectedValue, entityDisplayTrue, entityDisplayFalse, onChange } = props

  const options = useMemo<BooleanEntity[]>(
    () => [
      { display: entityDisplayTrue, value: true },
      { display: entityDisplayFalse, value: false },
    ],
    [entityDisplayTrue, entityDisplayFalse],
  )

  const a = options.find(o => o.value === selectedValue)

  return (
    <TomAutoComplete
      {...props}
      dataCy={dataCy ?? `${label.toLowerCase()}-boolean-autocomplete`}
      options={options}
      displayPopupIcon
      entityDisplayValue='display'
      entityKey='value'
      defaultValue={a}
      enablePortal
      placeholder={t('selectBooleanEntity', `Select ${label}`)}
      onChangeEntity={entity => {
        onChange(entity?.value)
      }}
    />
  )
})
